import styled, { keyframes } from 'styled-components';
import COLORS from '../../../style/universal.color';

interface PropsTypes {
  showOverlay?: boolean;
  color?: string;
  opacity?: number;
  animationDuration?: number;
  animateOut?: boolean;
}

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
`;

export const fadeOut = keyframes`
  to {
    opacity: 0;
  }
`;

export const Wrapper = styled.div<PropsTypes>`
  position: fixed;
  z-index: 99994;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${(props) => props.color || COLORS.mlbBlack};
  opacity: ${(props) => (props.showOverlay ? props.opacity || '0.5' : '0')};
  animation: ${(props) => (props.animateOut ? fadeOut : fadeIn)};
  animation-duration: ${(props) => props.animationDuration};
`;
